import styled from "styled-components";
import Colors from "../../themes/Colors";
import Fonts from "../../themes/Fonts";
import { fadeIn } from "../Common/CommonStyles";

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${(props) => props.width || "100%"};
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  @media screen and (max-width: 844px) {
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const TableWrapper = styled.div`
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "auto"};
  max-width: ${(props) => props.maxWidth || "1000px"};
  max-height: ${(props) => props.maxHeight || "auto"};
  min-width: ${(props) => props.minWidth || "auto"};
  min-height: ${(props) => props.minHeight || "auto"};
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  overflow: auto;

  /* Allow tooltips to overflow the table boundaries */
  position: relative;

  @media screen and (max-width: 844px) {
    width: auto;
    max-width: 400px;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  @media screen and (max-width: 844px) {
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const TableHeader = styled.thead`
  background-color: ${(props) => props?.headerColor || Colors.primaryPrimera};
  color: #fff;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  color: ${(props) => props?.textColor || Colors.primaryPrimera};
  text-align: center;
`;

export const TableHeaderCell = styled.th`
  padding: 12px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  background-color: ${(props) => props?.cellColor || Colors.primaryPrimera};
  text-align: center;
  width: ${(props) => props.width || "auto"};
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

export const TableCell = styled.td`
  padding: 12px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  text-align: center;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
`;

export const PaginationButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #ccc;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  background-color: ${({ active, paginationColor }) =>
    active ? paginationColor || Colors.primaryHumano : "transparent"};
  color: ${({ active }) => (active ? "#fff" : "#0e6eb8")};
  cursor: ${({ active }) => (active ? "default" : "pointer")};
  margin: 0 4px;

  &:hover {
    background-color: ${({ active }) => (active ? "#0e6eb8" : "#f2f2f2")};
    color: ${({ active }) => (active ? "#fff" : "#0e6eb8")};
  }
`;

export const CellSeparator = styled.th`
  width: ${(props) => props.width || ""};
  height: ${(props) => props.height || "1px"};
  background-color: ${(props) => props.backgroundColor || Colors.transparent};
`;
